module.exports = __webpack_public_path__ + "static/media/sara.da438eef.PNG";